/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
       $('#slider-two').slick({
          dots:false,
          arrows:false,
          infinite:true,
          autoplay:true,
          fade:true,
          autoplaySpeed:5000,
          centerMode:true,
          centerPadding:'20%',
          cssEase:'linear'
        });

       $('.mobile_nav_toggle').on('click', function(){
        $('.mobile_nav').show(200);
       });


       $('.menu-item-has-children').on('click', function() {
          $('.sub-menu').toggle(200);
       });

       $('.mobile_nav .close').on('click', function() {
        $('.mobile_nav').hide(200);
       })

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        $('#slider').slick({
          dots:false,
          infinite:true,
          arrows:true,
          appendArrows:'.slider-arrows',
          nextArrow: '<span class="slick-next">></span>',
          prevArrow: '<span class="slick-prev"><</span>',
          fade:true,
          autoplay:true,
          autoplaySpeed:5000,
          pauseOnFocus:false,
          cssEase:'linear'
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'guest_rooms' : {
      init: function() {
        $('.village-side-rooms').hide();

        $('.types li').on('click', function(){
          
          $('.types li').removeClass('selected');
          
          $(this).addClass('selected');
         
          var roomType = $(this).attr('data-id');
          
          roomType = roomType+'-rooms';
           
            $('.rooms-container').fadeOut(200);
           
            $('.'+roomType).fadeIn(200);
            
      
        });
    }
  }
};
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
